const themeConfig = {
  token: {
    colorPrimary: '#00AFEE',
    colorBgContainer: '#ffffff',
    colorBgLayout: '#f5f5f5',
    colorText: '#0F1543',
    borderRadius: 6,
    fontFamily: "'Inter', 'Helvetica Neue', Helvetica, Arial, sans-serif",
  },
  components: {
    Layout: {
      headerBg: '#ffffff',
      siderBg: '#0F1543',
      bodyBg: '#f5f5f5',
    },
    Menu: {
      darkItemBg: '#0F1543',
      darkItemColor: 'rgba(255, 255, 255, 0.65)',
      darkItemSelectedBg: '#00AFEE',
      darkItemSelectedColor: '#ffffff',
      darkItemHoverColor: '#ffffff',
      darkItemHoverBg: 'rgba(0, 175, 238, 0.2)',
    },
    Table: {
      headerBg: '#f8fafc',
      headerColor: '#64748b',
      headerFontWeight: 600,
      headerSplitColor: 'transparent',
      borderColor: '#f0f0f0',
      rowHoverBg: '#f0f7ff',
      cellPaddingBlock: 14,
      cellPaddingInline: 16,
      headerBorderRadius: 8,
    },
  },
};

export default themeConfig;
